export default {
  wallet: {
    title: 'Wallet',
    balance: 'Balanse',
    deposit: 'Deposit',
    withdraw: 'Mag-withdraw',
    rollover: 'Rollover',
    transaction: 'Transaksyon',
    myBet: 'Aking Taya',
    totalBalance: 'Kabuuang Balanse',
    withdrawableBalance: 'Balanseng Mababawi',
    bonus: 'Bonus',
    bonusBalance: 'Balanse ng Bonus',
    cashBalance: 'Balanse ng Cash',
    withdrawable: 'Pwedeng I-withdraw',
    depositNow: 'Mag-deposit Ngayon',
    getBonus: 'Kunin ang Bonus',
    bonusGames: 'Bonus na Laro',
    playNow: 'Maglaro Ngayon',
    fiatAccount: 'Fiat na Account',
    cash: 'Cash',
    rules: 'Mga Panuntunan',
    ruleQ1: '1. Ano ang Bonus?',
    ruleA1: 'Ang bonus ay mga gantimpalang ibinibigay ng platform pagkatapos sumali sa mga aktibidad at maaaring gamitin sa pagtaya sa mga itinalagang bonus na laro.',
    ruleQ2: '2. Paano ko magagamit ang bonus?',
    ruleA2: 'Ang bonus ay magagamit lamang sa pagtaya matapos maubos ang balanse ng cash wallet. Kailangang matugunan ng bonus ang wagering requirement bago ito ma-convert sa cash wallet.',
    ruleQ3: '3. Anong mga laro ang sumusuporta sa pagtaya gamit ang bonus?',
    ruleA3: 'Karamihan sa mga slot game ay sumusuporta sa pagtaya gamit ang bonus. Para sa detalyadong listahan ng mga laro, pakitingnan ang pahina ng Bonus na Laro.',
    ruleQ4: '4. May mga paghihigpit ba sa pag-convert ng bonus sa cash wallet?',
    ruleA4: 'Kapag natugunan na ang wagering requirement ng bonus, maaari mong i-convert ang orihinal na bonus sa cash wallet sa Rewards Center. Ang anumang natitirang kita ng bonus ay ibabalik sa Bonus Wallet, at muling kakalkulahin ang wagering requirement.',
    ruleQ5: '5. May mga paghihigpit ba sa pag-convert ng kita ng bonus sa cash wallet?',
    ruleA5: 'Ang kita ng bonus ay kailangang matugunan ang 15x na wagering requirement. Ang pinakamataas na kita ng bonus na maaaring i-convert sa cash wallet ay USDT5,000.00, at ang pinakamataas na halaga kada taya ay USDT1,000.00.',
    ruleQ6: '6. Paano kinakalkula ang wagering requirement?',
    ruleA6: 'Mga slot game: Halaga ng taya = Wagering requirement. Ibang laro: Halaga ng taya = Absolute value ng kita (hanggang sa halaga ng taya)',
    select: 'Pumili',
    currency: 'Pera',
    loading: 'Naglo-load...',
    noMoreData: 'Wala nang datos',
    noData: 'Walang datos',
    colType: 'Uri',
    colTime: 'Oras',
    colStatus: 'Status',
    colAmount: 'Halaga',
    colBalance: 'Balanse',
    allType: 'Lahat ng Uri',
    allStats: 'Lahat ng Status',
    colWallet: 'Wallet',
    colCurrent: 'Kasalukuyan',
    colRequired: 'Kailangan',
    colStats: 'Status',
    totalVaultBalance: 'Kabuuang Balanse ng Vault',
    amount: 'Halaga',
    availableBalance: 'Balanseng Magagamit:',
    max: 'MAX',
    depositInVault: 'Ideposit sa Vault',
    depositCurrency: 'Pera ng Deposit',
    currencyBalance: 'Balanse ng Pera',
    history: 'Kasaysayan',
    vaultRules: 'Mga Panuntunan ng Vault',
    vaultRule1: 'Ang Vault ay isang ligtas na lugar upang mag-imbak ng pondo nang hindi nag-aalala sa mga bayarin sa transaksyon o pagkaantala sa blockchain. Gumagana ang Vault tulad ng sarili mong digital wallet o kahit tulad ng savings account sa bangko. Napakaligtas nito – salamat sa 2FA – at maaari kang magpatupad ng pinahusay na hakbang sa seguridad upang pangalagaan ang mga pondo sa loob.',
    vaultRule2: 'Ang pag-deposit at pag-withdraw ng pondo sa Vault ay protektado ng 2FA at maaaring i-access ng may-ari anumang oras.',
    vaultRule3: 'Ang pondo sa Vault ay hindi hahawakan ninuman maliban sa may-ari nito. Sa iyo ito, at mananatili itong ligtas para gamitin mo!',
    selectTime: 'Pumili ng Oras',
    colGame: 'Laro',
    colBet: 'Taya',
    colWin: 'Panalo',
    colProfit: 'Kita',
    sports: 'Sports',
    allGames: 'Lahat ng laro',
    today: 'Ngayon',
    yesterday: 'Kahapon',
    last3Days: 'Huling 3 araw',
    last7Days: 'Huling 7 araw',
    last15Days: 'Huling 15 araw',
    last30Days: 'Huling 30 araw',
  },
};
